export const lastShownKey = "onpage_dialog_last_shown";
export const coolDownPeriodKey = "onpage_dialog_cool_down";
export var DialogEventType;
(function (DialogEventType) {
    DialogEventType["buttonClicked"] = "dialog_button_clicked";
    DialogEventType["closed"] = "dialog_closed";
    DialogEventType["ignored"] = "dialog_ignored";
    DialogEventType["injected"] = "dialog_injected";
    DialogEventType["injected_error"] = "dialog_injected_error";
    DialogEventType["initial_ping"] = "ping.initial";
    DialogEventType["received"] = "received";
})(DialogEventType || (DialogEventType = {}));
export var ShowOnpageDialogResult;
(function (ShowOnpageDialogResult) {
    ShowOnpageDialogResult[ShowOnpageDialogResult["ignored"] = 0] = "ignored";
    ShowOnpageDialogResult[ShowOnpageDialogResult["rejected"] = 1] = "rejected";
    ShowOnpageDialogResult[ShowOnpageDialogResult["shown"] = 2] = "shown";
    ShowOnpageDialogResult[ShowOnpageDialogResult["error"] = 3] = "error";
})(ShowOnpageDialogResult || (ShowOnpageDialogResult = {}));
export var DialogErrorEventType;
(function (DialogErrorEventType) {
    DialogErrorEventType["error_no_dialog_found"] = "error.no_ipm";
    DialogErrorEventType["get_no_dialog_found"] = "get.no_dialog";
    DialogErrorEventType["ping_no_dialog_found"] = "ping.no_dialog";
})(DialogErrorEventType || (DialogErrorEventType = {}));
